import { OrdersPage } from "src/app/@domain/modules/order/@orders.page"

export const OrderCreatePage = () => {
  return <OrdersPage isCreateOrder={true} />
}